import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../../services/api';
import dividuBlue from '../../assets/dividu-blue.svg';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [email, setEmail] = useState(location.state?.email || '');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (newPassword !== confirmPassword) {
            setError('As senhas não coincidem');
            setLoading(false);
            return;
        }

        if (newPassword.length < 6) {
            setError('A senha deve ter pelo menos 6 caracteres');
            setLoading(false);
            return;
        }

        try {
            await authService.resetPassword(email, code, newPassword);
            setSuccess(true);
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            setError(err.response?.data?.message || 'Código inválido ou expirado.');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="auth-page">
                <div className="auth-container">
                    <div className="auth-card">
                        <div className="auth-logo">
                            <img src={dividuBlue} alt="Dividu" style={{ height: '45px', width: 'auto' }} />
                        </div>
                        <h1 className="auth-title">Senha alterada!</h1>
                        <div className="alert alert-success">
                            <span>✅</span>
                            Sua senha foi redefinida com sucesso.
                        </div>
                        <p className="auth-subtitle">
                            Você será redirecionado para o login em instantes...
                        </p>
                        <div style={{ textAlign: 'center', marginTop: '24px' }}>
                            <Link to="/login" className="btn btn-primary btn-block btn-lg">
                                Ir para Login agora
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-logo">
                        <img src={dividuBlue} alt="Dividu" style={{ height: '70px', width: 'auto' }} />
                    </div>

                    <h1 className="auth-title">Redefinir Senha</h1>
                    <p className="auth-subtitle">Defina uma nova senha para sua conta</p>

                    {error && (
                        <div className="alert alert-error">
                            <span>⚠️</span>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="seu@email.com"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Código (6 dígitos)</label>
                            <input
                                type="text"
                                className="form-input"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder="Código recebido por email"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Nova Senha</label>
                            <input
                                type="password"
                                className="form-input"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Mínimo 6 caracteres"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Confirmar Senha</label>
                            <input
                                type="password"
                                className="form-input"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirme a nova senha"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary btn-block btn-lg"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="loading-spinner" style={{ width: 20, height: 20, borderWidth: 2 }}></span>
                                    Alterando...
                                </>
                            ) : (
                                'Alterar Senha'
                            )}
                        </button>
                    </form>

                    <div className="auth-footer">
                        <Link to="/login">Cancelar e voltar</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
